import { Controller } from "@hotwired/stimulus"

// "Total Recipients" on the Add Recipients step of Send a Gift.
//
// The rows are still rendered and swapped out by the give flow's own recipients
// form, so the count is read back off the rows rather than tracked: a row counts
// once it has someone to send to. That covers typing as well as rows arriving
// from Import Contacts and leaving through Clear All.
export default class extends Controller {
  static get targets() {
    return ["count", "continue"]
  }

  connect() {
    // Adding, importing and removing all replace the whole form, which is a
    // childList change here rather than anything the inputs report.
    this.observer = new MutationObserver(() => this.recount())
    this.observer.observe(this.element, { childList: true, subtree: true })
    this.recount()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  recount() {
    const total = Array.from(this.element.querySelectorAll(".build-recipient-row")).filter((row) =>
      this.addressed(row)
    ).length

    // Writing the count is itself a mutation inside the observed subtree, so
    // only write when it actually changed or the observer feeds itself forever.
    if (this.hasCountTarget && this.countTarget.textContent !== String(total)) {
      this.countTarget.textContent = total
    }

    this.continueTargets.forEach((button) => button.classList.toggle("btn-disabled", total === 0))
  }

  // A row is a recipient once its email (or phone) is valid, so a half-typed
  // address isn't counted yet. The name and the send date are both optional.
  addressed(row) {
    const { isValidEmail, isValidPhone } = window.ltFormValidators
    const email = row.querySelector("input[id$='email']")
    const phone = row.querySelector("input[id$='phone_number']")

    return (!!email && isValidEmail(email.value.trim())) || (!!phone && phone.value.trim() !== "" && isValidPhone(phone.value.trim()))
  }
}
